__turbopack_context__.v({
  "body": "_9TDtia_body",
  "calculateButton": "_9TDtia_calculateButton",
  "diagram": "_9TDtia_diagram",
  "hero": "_9TDtia_hero",
  "heroInner": "_9TDtia_heroInner",
  "heroTitle": "_9TDtia_heroTitle",
  "input": "_9TDtia_input",
  "label": "_9TDtia_label",
  "page": "_9TDtia_page",
  "placeholderHint": "_9TDtia_placeholderHint",
  "select": "_9TDtia_select",
  "table": "_9TDtia_table",
  "thenumber": "_9TDtia_thenumber",
  "unit": "_9TDtia_unit",
  "well": "_9TDtia_well",
});
